import { nullifyUndefinedProperties } from 'tradera-utils/object';

const getInitialPreferredLanguage = (
    languageCodeIso2,
    availableLanguages,
    defaultLanguage
) => {
    const availableIsoCodes = availableLanguages.map(
        lang => lang.languageCodeIso2
    );
    if (
        !!languageCodeIso2 &&
        availableIsoCodes.indexOf(languageCodeIso2) !== -1
    ) {
        return availableLanguages.find(
            l => l.languageCodeIso2 === languageCodeIso2
        );
    }

    return defaultLanguage;
};

export default initData => {
    const result = nullifyUndefinedProperties({
        preferred: getInitialPreferredLanguage(
            initData.languageCodeIso2,
            initData.availableLanguages || [],
            initData.defaultLanguage
        ),
        memberCountryCodeIso2: initData.memberCountryCodeIso2,
        available: initData.availableLanguages
    });
    return result;
};
